import { iconCircleCheck, iconClipboard } from "@kensho/icons";
import { Button } from "@kensho/neo";
import { use, useCallback, useEffect, useState } from "react";

import { SiteAnalyticsContext } from "../../../providers/site-analytics-context";
import { useTranscriptContext } from "../../../providers/use-transcript-context";
import { copyToClipboard } from "../../../utils/copy-text";
import { prettyText } from "../../../utils/transcript-utils";

/** Copy prettified transcript text to user's clipboard */
export function CopyToClipboardButton() {
  const { transcript } = useTranscriptContext();

  const analytics = use(SiteAnalyticsContext);

  const [copied, setCopied] = useState(false);

  const copyTranscript = useCallback((): void => {
    copyToClipboard(prettyText(transcript));
  }, [transcript]);

  useEffect(() => {
    if (!copied) return undefined;

    const timeout = setTimeout(() => {
      setCopied(false);
    }, 3000);

    return () => clearTimeout(timeout);
  }, [copied]);

  return (
    <Button
      onClick={() => {
        analytics.sendEvent("copy_transcript_to_clipboard");
        copyTranscript();
        setCopied(true);
      }}
      icon={copied ? iconCircleCheck : iconClipboard}
      minimal
      intent="primary"
      aria-label="Copy to clipboard"
    />
  );
}
